import axios from "axios"
import {toast} from "react-toastify";
import {getErrorText} from "./util";
import {getUserStore} from "./store/UserStore";
/**
 * @typedef {object} ResponseSuccessForm
 * @property {string} status
 * @property {object} data
 */
/**
 * @typedef {object} ResponseErrorForm
 * @property {string} code
 * @property {string} message
 */
const initializeApp = () => {

    // Setting base URL for all API request via axios
    axios.defaults.baseURL = import.meta.env.VITE_REACT_APP_BASE_URL
    axios.interceptors.request.use(function (config, custom) {
        // UPDATE: Add this code to show global loading indicator
        // console.log(config)
        if (config.headers?.skipInterceptor) {
            // Interceptor를 우회
            return config;
        }
        getUserStore().setLoadPending(true);
        return config
    }, function (error) {
        return Promise.reject(error);
    });

    axios.interceptors.response.use(function (response) {
        getUserStore().setLoadPending(false);
        return response;
    }, function (error) {
        getUserStore().setLoadPending();
        /** @type {ResponseErrorForm} */
        let errorData = {code: error.code, message: error.message};
        if (error.response.status === 400) {
            errorData = {code: error.response.data.error.code, message: error.response.data.error.message};
            if (['AUTH_TOKEN_EXPIRED', 'NOT_EXIST_AUTH_TOKEN'].includes(errorData.code)) {
                localStorage.removeItem("token")
                window.location.href = "/login"
            }
        }
        const errorMessageText = getErrorText(errorData.code);
        // const errorMessageText = ERROR_MESSAGE.find((itm) => itm.value === errorData.code);
        if (!['ALREADY_EXIST_FILE_NAME', 'ALREADY_EXIST_PRODUCT_LINK'].includes(errorData.code)) {
            toast(errorMessageText);
        }

        return Promise.reject(errorData);
    });
    if (!import.meta.env.MODE || import.meta.env.MODE === 'development') {
        axios.defaults.baseURL = import.meta.env.VITE_DEV_SERVER_URL
    } else {
    }
}

export default initializeApp
